module.exports = __webpack_public_path__ + "static/media/Cofagrigus_gaussian2.64c58e2e.png";